import React from 'react';
import s from './ToolsButtons.module.css';
import IconNote from '../../../../shared/ui/icons/IconNote';
import { useAppDispatch } from '../../../../store/store';

import { useSelector } from 'react-redux';

import { createProjectNote, setProjectNotes } from '../../../../store/slices/notesSlice';
import { useParams } from 'react-router-dom';
import { selectNotes } from '../../../../store/selectors/noteSelectors';

interface NoteButtonProps {
    isActive?: boolean;
    onClick?: () => void;
}

const NoteButton: React.FC<NoteButtonProps> = ({ isActive, onClick }) => {
    const dispatch = useAppDispatch();
    const { projectId } = useParams();

    const addNote = () => {
        if (onClick) onClick();
        if (!projectId) return;
        dispatch(
            createProjectNote({
                projectId: projectId,
                title: 'NEW',
                content: 'Your note here',
            }),
        );
    };

    return (
        <button className={`${s.container}`} onClick={addNote}>
            <IconNote />
            <p>Note</p>
        </button>
    );
};

export default NoteButton;
